<template>
  <div id="app">
    <keep-alive :include="['UnpaidBills', 'PaidBills', 'DeliveryList', 'User']">
      <router-view></router-view>
    </keep-alive>
    <van-tabbar 
      v-show="isTabbar" 
      :placeholder="true" 
      active-color="#1989fa" 
      inactive-color="#666666" 
      :route="true"
      :fixed="true"
      :safe-area-inset-bottom="true">
      <van-tabbar-item
        v-for="item of currentTabbars"
        :key="item.to"
        :icon="item.icon"
        :name="item.name"
        :to="item.to"
      >
        {{ item.title }}
      </van-tabbar-item>
    </van-tabbar>
    <home-button v-show="!isHomePage"></home-button>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant'
import HomeButton from './components/HomeButton.vue'
import { getUserInfo } from '@/api/user'

export default {
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    HomeButton
  },
  data() {
    return {
      isEmployee: false,
      customerTabbars: [
        {
          name: 'unpaid',
          title: '待支付',
          icon: 'balance-list-o',
          to: '/'
        },
        {
          name: 'paid',
          title: '已支付',
          icon: 'certificate',
          to: '/paid'
        },
        {
          name: 'user',
          title: '我的',
          icon: 'contact',
          to: '/user'
        }
      ],
      employeeTabbars: [
        {
          name: 'delivery',
          title: '送货列表',
          icon: 'logistics',
          to: '/delivery'
        },
        {
          name: 'user',
          title: '我的',
          icon: 'contact',
          to: '/user'
        }
      ]
    }
  },
  computed: {
    currentTabbars() {
      return this.isEmployee ? this.employeeTabbars : this.customerTabbars
    },
    isTabbar() {
      return this.currentTabbars.some(item => item.to === this.$route.path)
    },
    isHomePage() {
      return this.$route.path === '/' || this.$route.path === '/delivery'
    }
  },
  async created() {
    await this.checkUserRole()
  },
  methods: {
    async checkUserRole() {
      try {
        const res = await getUserInfo()
        if (res.code === 200 && res.user) {
          this.isEmployee = res.user.employee === true
          
          // 如果是员工用户且当前在普通用户页面，重定向到送货列表
          if (this.isEmployee && (this.$route.path === '/' || this.$route.path === '/paid')) {
            this.$router.replace('/delivery')
          }
          // 如果是普通用户且当前在员工页面，重定向到待支付页面
          else if (!this.isEmployee && this.$route.path === '/delivery') {
            this.$router.replace('/')
          }
        }
      } catch (error) {
        console.error('获取用户信息失败', error)
      }
    }
  }
}
</script>

<style lang="scss">
// 全局样式
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', sans-serif;
  -webkit-font-smoothing: antialiased;
}

// 移除路由过渡动画以提升切换速度

// 底部安全区适配
.pd-security {
  padding-bottom: constant(safe-area-inset-bottom); //兼容 IOS<11.2
  padding-bottom: env(safe-area-inset-bottom); //兼容 IOS>11.2
}

// 优化Tabbar样式
.van-tabbar {
  box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.van-tabbar-item {
  transition: all 0.2s ease;
}

.van-tabbar-item--active {
  transform: translateY(-2px);
}
</style>
